import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { transactionsTypes } from 'app-components/flux/transactions';
import { ROOT_MODAL_DRAWER_PROP } from 'components/Drawers/standardDrawerContract';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'MATCH_TXN_DIALOG';

export interface MatchTxnDialogProps {
  txn: transactionsTypes.TransactionProps;
  transactions?: ImmutableMap<string, transactionsTypes.TransactionRecord>;
  rootModalDrawer?: RootModalDrawerOptions;
  wrapperId?: string;
  onLinked?: () => void;
}

export const showMatchTxnDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ rootModalDrawer, ...otherProps }: MatchTxnDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        [ROOT_MODAL_DRAWER_PROP]: rootModalDrawer ?? { width: 'Large' },
        ...otherProps,
      }),
    }),
);
